import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b3ac972"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  href: "/",
  alt: "Home"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/careers",
  class: "ramp-nav-item no-mobile"
}, "Find Jobs", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/careers",
  class: "ramp-nav-item no-mobile"
}, "News", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"letter-spacing":"0"} }, "Login", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "text-center" }
const _hoisted_15 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    app: "",
    extended: "",
    class: _normalizeClass(["ramp-app-bar px-8", { 'header-minified': _ctx.isMinified }])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar_title, null, {
        default: _withCtx(() => [
          _createElementVNode("a", _hoisted_1, [
            _createVNode(_component_v_img, {
              height: 50,
              "max-width": 265,
              src: require('@/assets/images/transparent-bpo-logo.png'),
              contain: ""
            }, null, 8, ["src"])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_v_spacer),
      _hoisted_2,
      _hoisted_3,
      (_ctx.accountMenu)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 0,
            variant: "tonal",
            rounded: "s",
            height: "50",
            color: "white",
            class: "no-transform bold text-left no-mobile"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName) + " ", 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_icon, { class: "mdi mdi-menu-down" }),
              _createVNode(_component_v_menu, { activator: "parent" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { "min-width": "300" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_ctx.completeInfo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                                (_ctx.completeInfo.full_data.role.id==='377da95c-6518-4715-b32d-ac9825cb42bd')
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      href: "/dashboard/candidate"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_5, [
                                          _createVNode(_component_v_icon, { class: "mdi mdi-account-circle" }),
                                          _createTextVNode(" My Account")
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      href: "/dashboard"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_6, [
                                          _createVNode(_component_v_icon, { class: "mdi mdi-account-circle" }),
                                          _createTextVNode(" My Account")
                                        ])
                                      ]),
                                      _: 1
                                    }))
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            href: "/careers",
                            else: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_7, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-tie" }),
                                _createTextVNode(" Careers")
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, {
                            onClick: _ctx.logOut,
                            class: "header-menu-logout"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
                                class: "text-center"
                              }, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-logout-variant" }),
                                _createTextVNode(" Log-out")
                              ])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            to: "/login",
            variant: "tonal",
            rounded: "s",
            height: "50",
            class: "ramp-nav-button no-transform bold no-mobile"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })),
      (_ctx.accountMenu)
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 2,
            variant: "tonal",
            rounded: "s",
            height: "50",
            color: "white",
            class: "no-transform bold text-left mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { class: "mdi mdi-account" }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_icon, { class: "mdi mdi-menu-down" }),
              _createVNode(_component_v_menu, { activator: "parent" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { "min-width": "300" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          (_ctx.completeInfo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                _createVNode(_component_v_list_item, { class: "text-info" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "mdi mdi-account" }),
                                    _createTextVNode(" " + _toDisplayString(_ctx.firstName) + " " + _toDisplayString(_ctx.lastName), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_divider),
                                (_ctx.completeInfo.full_data.role.id==='377da95c-6518-4715-b32d-ac9825cb42bd')
                                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 0,
                                      href: "/dashboard/candidate"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_10, [
                                          _createVNode(_component_v_icon, { class: "mdi mdi-account-circle" }),
                                          _createTextVNode(" My Account")
                                        ])
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: 1,
                                      href: "/dashboard"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_11, [
                                          _createVNode(_component_v_icon, { class: "mdi mdi-account-circle" }),
                                          _createTextVNode(" My Account")
                                        ])
                                      ]),
                                      _: 1
                                    }))
                              ]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            href: "/careers",
                            else: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_12, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-tie" }),
                                _createTextVNode(" Careers")
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, {
                            onClick: _ctx.logOut,
                            class: "header-menu-logout"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", {
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args))),
                                class: "text-center"
                              }, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-logout-variant" }),
                                _createTextVNode(" Log-out")
                              ])
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_v_btn, {
            key: 3,
            variant: "tonal",
            rounded: "s",
            height: "40",
            size: "small",
            color: "white",
            class: "no-transform bold text-left mobile"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_icon, { class: "mdi mdi-menu" }),
              _createVNode(_component_v_menu, { activator: "parent" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card, { "min-width": "300" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, {
                            href: "/careers",
                            else: ""
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_13, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-tie" }),
                                _createTextVNode(" Careers")
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, {
                            class: "header-menu text-blue",
                            href: "/registration"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_14, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-file-sign" }),
                                _createTextVNode(" Register")
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_divider),
                          _createVNode(_component_v_list_item, {
                            class: "header-menu text-green",
                            href: "/login"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", _hoisted_15, [
                                _createVNode(_component_v_icon, { class: "mdi mdi-login-variant" }),
                                _createTextVNode(" Login")
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["class"]))
}